import React, { useEffect, useState } from "react";
import api from "../../services/api";

import PageHeader from "../components/PageHeader";
import SearchBar from "../components/SearchBar";
import DataTable from "../components/DataTable";
import Loader from "../components/Loader";
import ConfirmModal from "../components/ConfirmModal";

import API_URL from "../../config";

const Payments = () => {

    const [loading, setLoading] = useState(true);

    const [payments, setPayments] = useState([]);

    const [filteredPayments, setFilteredPayments] = useState([]);

    const [search, setSearch] = useState("");

    const [selectedPayment, setSelectedPayment] = useState(null);

    const [deleteId, setDeleteId] = useState(null);

    useEffect(() => {

        fetchPayments();

    }, []);

    useEffect(() => {

        filterPayments();

    }, [payments, search]);

    const fetchPayments = async () => {

        try {

            setLoading(true);

            const response = await api.get("/admin/payments");

            setPayments(response.data.data || []);
            setFilteredPayments(response.data.data || []);

        } catch (error) {

            console.error("Error fetching payments:", error);

        } finally {

            setLoading(false);

        }

    };

    const filterPayments = () => {

        if (!search.trim()) {

            setFilteredPayments(payments);

            return;

        }

        const keyword = search.toLowerCase();

        const filtered = payments.filter((payment) =>

            payment.company_name?.toLowerCase().includes(keyword) ||

            payment.plan_name?.toLowerCase().includes(keyword) ||

            payment.payment_status?.toLowerCase().includes(keyword) ||

            payment.transaction_id?.toLowerCase().includes(keyword)

        );

        setFilteredPayments(filtered);

    };

    const handleDelete = async () => {

        if (!deleteId) return;

        try {

            await api.delete(
                `${API_URL}/admin/payments/${deleteId}`
            );

            fetchPayments();

        } catch (error) {

            console.error("Delete failed:", error);

        }

    };

    const columns = [

        {
            key: "id",
            label: "ID"
        },

        {
            key: "company_name",
            label: "Company"
        },

        {
            key: "plan_name",
            label: "Plan"
        },

        {
            key: "amount",
            label: "Amount"
        },

        {
            key: "payment_status",
            label: "Status"
        },

        {
            key: "payment_date",
            label: "Payment Date"
        }

    ];
        if (loading) {

        return (

            <Loader
                fullScreen={true}
                text="Loading Payments..."
            />

        );

    }

    return (

        <div className="space-y-6">

            <PageHeader

                title="Payments"

                subtitle="Manage payment transactions and subscriptions"

                showButton={false}

                breadcrumb={[
                    {
                        label: "Dashboard",
                        link: "/admin"
                    },
                    {
                        label: "Payments"
                    }
                ]}

            />

            <div className="bg-white rounded-3xl shadow-lg p-6">

    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

        <SearchBar
            value={search}
            onChange={setSearch}
            onClear={() => setSearch("")}
            placeholder="Search payments..."
        />

    </div>

    <DataTable
        title="Payment History"
        columns={columns}
        data={filteredPayments}
        emptyMessage="No payments found."
        actions={(payment) => (

            <div className="flex flex-wrap justify-center gap-2">

                <button
                    onClick={() => setSelectedPayment(payment)}
                    className="px-3 py-2 rounded-xl bg-blue-100 text-blue-600 hover:bg-blue-200 transition"
                >
                    View
                </button>

                {payment.invoice_url && (

                    <a
                        href={payment.invoice_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-3 py-2 rounded-xl bg-green-600 text-white hover:bg-green-700 transition"
                    >
                        Invoice
                    </a>

                )}

                <button
                    onClick={() => setDeleteId(payment.id)}
                    className="px-3 py-2 rounded-xl bg-red-100 text-red-600 hover:bg-red-200 transition"
                >
                    Delete
                </button>

            </div>

        )}
    />

</div>

            <ConfirmModal
    open={deleteId !== null}
    title="Delete Payment"
    message="Are you sure you want to delete this payment record?"
    confirmText="Delete"
    onConfirm={() => {
        handleDelete();
        setDeleteId(null);
    }}
    onCancel={() => setDeleteId(null)}
/>
                        {selectedPayment && (

<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 overflow-auto">

<div className="bg-white rounded-3xl shadow-2xl w-full max-w-5xl p-8 my-10">

<div className="flex justify-between items-center mb-8">

<h2 className="text-2xl font-bold">
Payment Details
</h2>

<button
onClick={() => setSelectedPayment(null)}
className="text-2xl text-gray-500 hover:text-red-500"
>
✕
</button>

</div>

<h3 className="text-xl font-semibold border-b pb-2 mb-6">
Payment Information
</h3>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">

<Detail label="Transaction ID" value={selectedPayment.transaction_id} />

<Detail label="Company" value={selectedPayment.company_name} />

<Detail label="Subscription Plan" value={selectedPayment.plan_name} />

<Detail
label="Amount"
value={`₹ ${Number(selectedPayment.amount || 0).toLocaleString()}`}
/>

<Detail label="Payment Method" value={selectedPayment.payment_method} />

<Detail label="Status" value={selectedPayment.payment_status} />

<Detail label="Payment Date" value={selectedPayment.payment_date} />

<Detail label="Expiry Date" value={selectedPayment.expiry_date} />

</div>

<h3 className="text-xl font-semibold border-b pb-2 mb-6">
Recruiter Information
</h3>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">

<Detail label="Recruiter" value={selectedPayment.recruiter_name} />

<Detail label="Email" value={selectedPayment.email} />

<Detail label="Phone" value={selectedPayment.phone} />

<Detail label="GST Number" value={selectedPayment.gst_number} />

</div>

<div>

<p className="text-sm text-gray-500 mb-2">
Invoice
</p>

{selectedPayment.invoice_url ? (

<a
href={selectedPayment.invoice_url}
target="_blank"
rel="noopener noreferrer"
className="inline-block px-4 py-2 rounded-xl bg-green-600 text-white hover:bg-green-700"
>
Download Invoice
</a>

) : (

<p className="text-gray-500">
Invoice not available.
</p>

)}

</div>

<div className="flex justify-end mt-8">

<button
onClick={() => setSelectedPayment(null)}
className="px-6 py-2 rounded-xl bg-gray-200 hover:bg-gray-300"
>
Close
</button>

</div>

</div>

</div>

)}
                    </div>

    );

};
const Detail = ({ label, value }) => (
    <div>
        <p className="text-sm text-gray-500">{label}</p>
        <p className="font-semibold text-gray-800">
            {value || "-"}
        </p>
    </div>
);
export default Payments;